module.exports = "/reports/components/salesTableComponent-a224ac.html";